import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../authentication/auth.service';
import { from, map, catchError, switchMap, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUserAccount } from '../../store/selectors/app.selectors';
import { RequiredUserAccountAction } from '../../shared/models/api/user';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const store = inject(Store);
  const router = inject(Router);

  return from(authService.isAuthenticated()).pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) {
        console.log('User is authenticated, allowing access to route:', state.url);
        return true;
      } else {
        console.log('User is not authenticated, redirecting to login.');
        authService.logout();
        return false;
      }
      return true;
    }),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        return from([false]);
      }

      // Check for password change requirement if user account is already loaded
      return store.select(selectUserAccount).pipe(
        take(1),
        map((account) => {
          // Only check if account exists (already logged in)
          if (account?.requiredActions?.includes(RequiredUserAccountAction.UPDATE_PASSWORD)) {
            // Only redirect if not already on the update-password route
            if (!state.url.includes('update-my-password')) {
              router.navigate(['/update-my-password'], {
                queryParams: { isPasswordChangeRequired: true }
              });
              return false;
            }
          }
          return true;
        })
      );
    }),
    catchError((error) => {
      console.error('Authentication check failed:', error);
      authService.logout();
      return from([false]);
    })
  );
};
